export const APPID = window.wxappid

export const logo_img = 'https://cdn-cp.tmuyun.com/oss-static/img/public/logo_color.png'



// WEBPACK FOOTER //
// ./src/config/config.js